import React, { useMemo } from 'react';
import NewProductReleases from 'src/components/new-product-releases';
import { usePersonalizedQuery } from 'src/hooks/use-personalized-query';
import type { NewCategoryProductsQuery } from 'src/types';
import query from './query.graphql';

type NewCategoryProductsProps = {
  categoryId: string;
};

export const NewCategoryProducts: React.FC<NewCategoryProductsProps> = ({
  categoryId,
}) => {
  const result = usePersonalizedQuery<NewCategoryProductsQuery>({
    query,
    queryKey: ['newProducts'],
    variables: {
      categoryId,
    },
  });

  const newReleases = result.data?.category?.newReleases;
  const preReleases = result.data?.category?.preReleases;

  const products = useMemo<any[]>(
    () => [...(newReleases?.nodes ?? []), ...(preReleases?.nodes ?? [])],
    [newReleases, preReleases]
  );

  if (result.isError || (!newReleases && !preReleases)) {
    return null;
  }

  return <NewProductReleases newReleases={products} />;
};
